import { fetchBasicJsonPost, fetchBasicUrlGetJson, fetchBasicUrlPost, fetchBasicUrlPostJson } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicUrlPostJson(
            '/Medicament/GetMedicamentGridData',
            {
                asGridData: true,
                data: parameters,
                signal
            },
            {
                useBlock: !signal
            }
        );
    },
    delete: (code) => fetchBasicUrlPost(
        '/Medicament/Delete',
        {
            data: { code: code },
        }
    ),
    setUnit: data => fetchBasicJsonPost('/Medicament/SetUnit', { data: data }),
    getDefaultUnit: medicamentCode => fetchBasicUrlGetJson('/Medicament/GetDefaultUnit', { data: { medicamentCode } }),
    getConvertUnits: medicamentCode => fetchBasicUrlGetJson('/Medicament/GetConvertUnits', { data: { medicamentCode } }),
};
